import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { WarningAmberRounded as WarningIcon, InfoOutlined as InfoIcon } from '@material-ui/icons'
import { TextLink } from './ui'

const FIX_LABEL = {
  remove: 'Remove',
  addPhenotype: 'Add phenotype',
  aiOff: 'Run without AI',
  // Older name of aiOff.
  noAI: 'Run without AI',
  clear: 'Clear',
  pickNormal: 'Pick a normal',
  split: 'Split lanes',
  dismissSheet: 'Dismiss',
  confirmNormal: 'Confirm',
  details: 'Open details',
}

// Row issues as short lines with text-button fixes. Blocking issues use the
// warning icon in ink; the others an info icon in muted text. Nothing is tinted.
const IssueList = ({ issues, onFix, sx }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, ...sx }}>
    {issues.map((issue) => (
      <Box key={issue.code} sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minHeight: 24, flexWrap: 'wrap' }}>
        {issue.blocking ? (
          <WarningIcon sx={{ fontSize: 16, color: 'text.primary' }} />
        ) : (
          <InfoIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
        )}
        <Typography sx={{ fontSize: 13, color: issue.blocking ? 'text.primary' : 'text.secondary' }}>
          {issue.text}
        </Typography>
        {onFix &&
          (issue.fixes || []).map((fix) => (
            <TextLink key={fix} onClick={() => onFix(fix, issue)} sx={{ ml: 1 }}>
              {FIX_LABEL[fix] || fix}
            </TextLink>
          ))}
      </Box>
    ))}
  </Box>
)

export default IssueList
